import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import { MatLegacyAutocomplete as MatAutocomplete } from '@angular/material/legacy-autocomplete';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyOption as MatOption } from '@angular/material/legacy-core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {map, startWith} from 'rxjs/operators';
import {Contact} from '../../mail-flow/add-recipients/add-recipients.component';
import {Observable} from 'rxjs';
import {IdexService} from '../../../idex.service';
import { Toast } from 'app/shared/toast/toast';

declare var $: any;

@Component({
   selector: 'app-reassign-dialog',
   templateUrl: './reassign-dialog.component.html',
   styleUrls: ['./reassign-dialog.component.css']
})
export class ReassignDialogComponent implements OnInit {
   @ViewChild('btnadd') btnAdd: MatButton;
   @ViewChild('matAutocompleteName') matAutocomplete: MatAutocomplete;
   @ViewChild('matAutocompleteEmail') matAutocompleteEmail: MatAutocomplete;
   @ViewChild('contactOpt') contactOpt: MatOption;
   @ViewChild('contactEmailOpt') contactEmailOpt: MatOption;
   @ViewChild('toolbar') toolbar: ElementRef;
   public inputInserted;
   public emailInserted;
   public groupInserted;
   public actionSelected;
   public checkEmail: boolean;
   errorMessage: string;
   contacts: Contact[] = [];
   emails: Contact[] = [];
   filteredOptions: Observable<Contact[]>;
   nameContr = new FormControl();
   emailContr = new FormControl();

   constructor(private dialogRef: MatDialogRef<ReassignDialogComponent>, private translate: TranslateService,
               public services: IdexService, @Inject(MAT_DIALOG_DATA) public data: any, private toast: Toast) {
   }

   ngOnInit() {
      this.clearControl();
   }

   /**
    * function เครียร์ค่าต่างๆ
    * Paramenter : inputType : ข้อมูลที่รับจากแป้นพิมพ์
    */
   clearControl() {
      this.inputInserted = '';
      this.emailInserted = '';
      this.groupInserted = '';
      this.actionSelected = 'NS';
      this.contacts = [];
      this.emails = [];
      this.filteredOptions = undefined;
   }

   selectKeyPress(event, cont: any) {
      if (event.key === 'Enter') {
         return;
      }
      this.filteredOptions = this.nameContr.valueChanges
         .pipe(
            startWith<string | Contact>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this.filter(name) : null)
         );
   }

   /**
    * function แปลงตัวอักษร
    * Paramenter : keyword : ข้อมูลที่รับจากแป้นพิมพ์
    */

   filter(keyword: string): Contact[] {
      const cont = this.contacts.filter(contact =>
         contact.name.toLowerCase().indexOf(keyword.toLowerCase()) === 0
         || contact.email.toLowerCase().indexOf(keyword.toLowerCase()) === 0);

      return cont;
   }

   highlightFirstOption(event, input): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.contacts = [];
      const kw = input.trim();
      this.contacts = this.getSearch(kw);
      this.matAutocomplete._keyManager.setFirstItemActive();
   }

   /**
    * function ที่เอาตัวแปรจาก event มาใส่ในตัวแปร
    * Paramenter : evt : event listener ,contactOpt : data of input data
    */
   selectContact(evt: any, contactOpt: any, cont: any): void {
      if (evt.source) {
         this.inputInserted = contactOpt.name;
         this.emailInserted = contactOpt.email;
         this.groupInserted = contactOpt.id;
      }
   }

   selectKeyPressEmail(event, cont: any) {
      if (event.key === 'Enter') {
         return;
      }
      this.filteredOptions = this.emailContr.valueChanges
         .pipe(
            startWith<string | Contact>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this.filter(name) : null)
         );
   }

   highlightFirstOptionEmail(event, input): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.emails = [];
      const kw = input.trim();
      this.emails = this.getSearch(kw);
      this.matAutocompleteEmail._keyManager.setFirstItemActive();
   }

   validateEmail(cont: any) {
      // This is intentional.
   }

   displayEmailFn(contact?: Contact): string | undefined {
      let email: any;
      if (contact !== null && contact !== undefined && contact.email !== undefined) {
         email = contact ? contact.email : '';
      } else {
         email = contact ? contact : '';
      }
      return contact ? email : '';
   }

   displayFn(contact?: Contact): string | undefined {
      let name: any;
      if (contact !== null && contact !== undefined && contact.name !== undefined) {
         name = contact ? contact.name : '';
      } else {
         name = contact ? contact : '';
      }
      return contact ? name : '';
   }

   /**
    * On dialog Reassign click action submit Reassign then call checkReassign
    * Paramenter : nameReassignTo ชื่อของคนที่ทำ Action Reassign, reassignTo email ของคนที่ทำ Action Reassign
    */
   onClickReAssign(nameReassignTo: string, reassignTo: string) {
      this.checkReassign(reassignTo, this.data.item.taskId, nameReassignTo, this.data.item);
   }

   /**
    * Call service check permission reassign
    * Paramenter : nameReassignTo ชื่อของคนที่ทำ Action Reassign, reassignTo email ของคนที่ทำ Action Reassign
    *              data ข้อมูลเริ่มต้นของ Task ที่ service ส่งมาในตอนแรก
    */
   checkReassign(reassignTo: string, taskId: number, nameReassignTo, data) {
      const nameValue = nameReassignTo.trim();
      if (/[<|>\\\/:?*']/g.test(nameValue)) {
         this.translate.get('alert.create_folder_error').subscribe(s => {
            this.errorMessage = s;
            $('#hint').addClass('hint-block');
            $('#hint').remove('hint-none');
         });
         return;
      } else {
         this.data.service.checkReassign(reassignTo.toLowerCase(), taskId).subscribe(response => {
            if (response) {
               this.data.service.reAssign(reassignTo, nameReassignTo, data).subscribe(data1 => {
                  this.data.toast.success(data1);
                  this.checkEmail = true;
                  $('#hint').addClass('hint-none');
                  $('#hint').remove('hint-block');
                  this.dialogRef.close(true);
               });
            } else {
               this.checkEmail = false;
               this.translate.get('taskMenu.hint_ressign').subscribe(s => {
                  this.errorMessage = s;
               });
               $('#hint').addClass('hint-block');
               $('#hint').remove('hint-none');
            }
         });
      }
   }

   getSearch(kw: any) {
      let search = [];
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else if (kw.length > 0) {
         this.services.getContactShare(kw)
            .subscribe(
               data => {
                  for (const element of data) {
                     search.push({
                           id: element.contactId,
                           name: element.fullName,
                           email: element.email,
                        });
                     }
                  search.sort((a, b) => a.name.localeCompare(b.name));
                  }, error => {
                     this.errorMessage = error;
                  });
         } else {
            search = [];
         }
      return search;
   }
}
